import { render, staticRenderFns } from "./FullWidth.vue?vue&type=template&id=6c6fd2ba&scoped=true"
import script from "./FullWidth.vue?vue&type=script&lang=js"
export * from "./FullWidth.vue?vue&type=script&lang=js"
import style0 from "./FullWidth.vue?vue&type=style&index=0&id=6c6fd2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6fd2ba",
  null
  
)

export default component.exports